export default __webpack_public_path__ + "static/media/advanced-filter-group-opened.048fad7a.svg";